import React, { lazy, Suspense, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { RecaptchaScriptLoader } from "./RecaptchaScriptLoader";
import RouteFallback from "./components/RouteFallback";

const Site = lazy(() => import("./Site"));
const AreaInvestidor = lazy(() => import("./AreaInvestidor"));
const NotFound = lazy(() => import("./pages/NotFound"));

/** Formata um segmento de URL: "acesso-negado" → "Acesso Negado", "paineisAdmin" → "Paineis Admin" */
function formatarSegmento(seg) {
  if (!seg) return "";
  return seg
    .split("-")
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
    .join(" ");
}

/** Deriva o título da rota atual (pathname). Rotas /areainvestidor/:rota/... ficam por investimento + seção. */
function tituloDaRota(pathname) {
  if (!pathname || pathname === "/") return "MSM Group | Inteligência Imobiliária De Ponta a Ponta";

  const partes = pathname.split("/").filter(Boolean);
  if (partes[0] === "areainvestidor") {
    // /areainvestidor ou /areainvestidor/:rota/...
    if (partes.length === 1) return "Área do Investidor | MSM Group";
    const investimento = formatarSegmento(partes[1]);
    const secoes = partes.slice(2).map(formatarSegmento).filter(Boolean);
    const tituloSecoes = [investimento, ...secoes].join(" · ");
    return `Área do Investidor · ${tituloSecoes} | MSM Group`;
  }

  const segmento = partes[0] || "";
  if (!segmento) return "MSM Group";
  const formatado = formatarSegmento(segmento);
  return `${formatado} | MSM Group`;
}

/** A cada rota: atualiza document.title e envia page_view ao GA4 (rota identificada pelo pathname). */
function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    const pathname = location.pathname;
    const title = tituloDaRota(pathname);
    document.title = title;
    if (typeof window.gtag === "function") {
      const pagePath = pathname + location.search;
      const pageLocation = typeof window.location !== "undefined"
        ? window.location.origin + pagePath
        : "";
      window.gtag("event", "page_view", {
        page_path: pagePath,
        page_title: title,
        page_location: pageLocation,
      });
    }
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <>
      <PageViewTracker />
      <RecaptchaScriptLoader />

      <Suspense fallback={<RouteFallback />}>
        <Routes>
          {/* Área protegida — antes do splat do site para não competir com /* */}
          <Route path="/areainvestidor/*" element={<AreaInvestidor />} />

          {/* Site público */}
          <Route path="/*" element={<Site />} />

          {/* Fallback global */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
